import React from "react";
import MainContainer from "../../components/MainContainer";
import { Link, Navigate, useLocation } from "react-router-dom";
import { appConfig } from "../../config";
import { useAuth } from "../../providers/AuthProvider";

const LoginPage = () => {
  const { isAuth } = useAuth();
  const location = useLocation();
  if (isAuth) {
    return (
      <Navigate
        to={
          location.pathname.includes("ticket-office")
            ? "/ticket-office/confirmation"
            : "/tickets/confirmation"
        }
      />
    );
  }

  return (
    <MainContainer>
      <div className="col-lg-8">
        <Link
          className="btn btn-back mb-4"
          to={
            location.pathname.includes("ticket-office")
              ? "/ticket-office"
              : "/tickets"
          }
        >
          <svg
            className="govgr-svg-icon--caret govgr-svg-icon"
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M18,22V2L6,12L18,22z"></path>
          </svg>
          Πίσω
        </Link>
        <h1 className="mb-4">Απαιτείται ταυτοποίηση</h1>
        <p>Για να προχωρήσετε, πρέπει πρώτα να συνδεθείτε.</p>
        <a
          href={`${appConfig.url}/oauth2/authorization/taxis`}
          className="btn btn-primary btn-lg btn-login mt-4"
        >
          <svg
            className="MuiSvgIcon-root"
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
          </svg>
          <span>Σύνδεση</span>
        </a>
      </div>
    </MainContainer>
  );
};

export default LoginPage;
